import { render } from "./ThePaymentsDetails.vue?vue&type=template&id=52e13b1c"
import script from "./ThePaymentsDetails.vue?vue&type=script&lang=js"
export * from "./ThePaymentsDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__